import qs from 'qs';

export function queryStringToParameters(queryString = '') {
  const queryQS = qs.parse(queryString, { ignoreQueryPrefix: true });

  const removeDuplicateQueryInArray = Object.keys(queryQS).reduce((result, key) => {
    const value = queryQS[key];
    if (Array.isArray(value)) {
      return {
        ...result,
        [key]: value.pop(),
      };
    }

    return {
      ...result,
      [key]: value,
    };
  }, {});

  return removeDuplicateQueryInArray;
}

export function objectToQueryString(object = {}) {
  return qs.stringify(object, {
    addQueryPrefix: true,
  });
}

function splitUrlBy(value) {
  return url => {
    if (url.includes(value)) {
      return url.split(value)[0];
    }
    return url;
  };
}

export const removeQueryString = splitUrlBy('?');

export const removeHashFromUrl = splitUrlBy('#');

export function urlData(url) {
  const a = document.createElement('a');

  a.href = url;

  return a;
}
